// Actions
export const CHANGE_CONTENT_SYNC_STATUS = 'SYSTEM/CHANGE_CONTENT_SYNC_STATUS'
export const OFFLINE_INIT = 'SYSTEM/OFFLINE_INIT'

// Commits
export const SET_CONTENT_SYNCED = 'SYSTEM/SET_CONTENT_SYNCED'
export const SET_CONTENT_SYNCED_DATE = 'SYSTEM/SET_CONTENT_SYNCED_DATE'
